import './styles/Popup.css';
import React from "react";

const Popup = ({dismiss, content}) => {
  return (
    <div className="popup-box">
      <div className="box">
        <span className="close-icon" onClick={dismiss}>x</span>
        {content}
      </div>
    </div>
  );
};
 
export default Popup;